@if (canSee() && dropDownMenu) {
  <button mat-menu-item
    title="Shift Harvest"
    [disabled]="this.disabled"
    (click)="click()"
    >
    <mat-icon aria-hidden="false" aria-label="Shift Harvest">compare_arrows</mat-icon>
    <span>Shift Harvest</span>
  </button>
}
@if (canSee() && !dropDownMenu) {
  <button class="gridbtn" mat-raised-button (click)="click()" title="Shift Harvest">
    <mat-icon aria-hidden="false" aria-label="Shift Harvest">compare_arrows</mat-icon>
  </button>
}